"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocationInfo = void 0;
const constants_1 = require("./constants");
exports.getLocationInfo = (address, addressComponents) => {
    const location = {
        name: address,
        streetAddress: address,
    };
    addressComponents.forEach(e => {
        if (e.types.includes(constants_1.ADMINISTRATIVE_AREA_LEVEL_1)) {
            location.state = e.long_name;
        }
        else if (e.types.includes(constants_1.ADMINISTRATIVE_AREA_LEVEL_2)) {
            location.city = e.long_name;
        }
        else if (e.types.includes(constants_1.COUNTRY)) {
            location.state = e.long_name;
        }
        else if (e.types.includes(constants_1.POSTAL_CODE)) {
            location.postalCode = e.long_name;
        }
    });
    return location;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9nb29nbGUtcGxhY2VzLWF1dG9jb21wbGV0ZS91dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7QUFJSCwyQ0FBNkc7QUFHaEcsUUFBQSxlQUFlLEdBQUcsQ0FBQyxPQUFlLEVBQUUsaUJBQW1ELEVBQUUsRUFBRTtJQUN0RyxNQUFNLFFBQVEsR0FBYztRQUMxQixJQUFJLEVBQUUsT0FBTztRQUNiLGFBQWEsRUFBRSxPQUFPO0tBQ3ZCLENBQUM7SUFFRixpQkFBaUIsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLEVBQUU7UUFDNUIsSUFBSSxDQUFDLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyx1Q0FBMkIsQ0FBQyxFQUFFO1lBQ2pELFFBQVEsQ0FBQyxLQUFLLEdBQUcsQ0FBQyxDQUFDLFNBQVMsQ0FBQztTQUM5QjthQUFNLElBQUksQ0FBQyxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsdUNBQTJCLENBQUMsRUFBRTtZQUN4RCxRQUFRLENBQUMsSUFBSSxHQUFHLENBQUMsQ0FBQyxTQUFTLENBQUM7U0FDN0I7YUFBTSxJQUFJLENBQUMsQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLG1CQUFPLENBQUMsRUFBRTtZQUNwQyxRQUFRLENBQUMsS0FBSyxHQUFHLENBQUMsQ0FBQyxTQUFTLENBQUM7U0FDOUI7YUFBTSxJQUFJLENBQUMsQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLHVCQUFXLENBQUMsRUFBRTtZQUN4QyxRQUFRLENBQUMsVUFBVSxHQUFHLENBQUMsQ0FBQyxTQUFTLENBQUM7U0FDbkM7SUFDSCxDQUFDLENBQUMsQ0FBQztJQUVILE9BQU8sUUFBUSxDQUFDO0FBQ2xCLENBQUMsQ0FBQyJ9